import { api } from '@/components/Functional/lib/request'
import { logger } from '@/components/Functional/utils/logger'
import {
  type GetShareSnsParams,
  type RecordShareSnsTapRequest,
  type ShareSnsData,
  ShareSnsDataSchema,
  type ShareSnsTapResponse,
  ShareSnsTapResponseSchema,
} from '@/schemas/v2/share-sns'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

/**
 * 拡散用SNS情報を取得する（GET /api/v2/spots/{id}/share-sns・認証任意）。
 * context=stamp のときは stampId 必須。context=ar_photo では不要。
 */
export async function fetchSpotShareSns(
  spotId: number,
  params: GetShareSnsParams,
  options?: FetchOptions,
): Promise<ShareSnsData> {
  const query = new URLSearchParams({ context: params.context })
  if (params.stampId != null) query.set('stampId', String(params.stampId))
  const url = `${BASE}/api/v2/spots/${spotId}/share-sns?${query.toString()}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return ShareSnsDataSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

/** 拡散用SNSのタップを記録する（POST /api/v2/spots/{id}/share-sns/taps・認証任意）。 */
export async function recordShareSnsTap(
  spotId: number,
  body: RecordShareSnsTapRequest,
  options?: FetchOptions,
): Promise<ShareSnsTapResponse> {
  const url = `${BASE}/api/v2/spots/${spotId}/share-sns/taps`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, body, options)
    return ShareSnsTapResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
